const PromoCodes = require("./containers/PromoCodes");
const AuthenticateAdmin = require("../utils").authenticateAdmin;

// Sync route definition
module.exports = {
    path: "/admin/promocodes/add",
    component: AuthenticateAdmin(PromoCodes),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-add/index.js